module.exports = __webpack_public_path__ + "img/app-header.e81f746c.png";